import { MessageBox } from "element-ui";
import vi18n from './vi18n'

//删除二次确认弹窗
export const isComfirm = (data, callback) => {
    MessageBox.confirm(vi18n.locale === 'zh' ? '确认后，内容将无法找回' :'Once confirmed, the content cannot be recovered', vi18n.locale === 'zh' ? '确认删除这行内容?':'Are you sure you want to delete this line of content?', {
        customClass: 'dataM',
        dangerouslyUseHTMLString: true,
        confirmButtonText: vi18n.locale === 'zh' ? '确定' : 'Confirm',
        cancelButtonText:  vi18n.locale === 'zh' ? '取消' : 'Cancel',
        type: 'warning'
    }).then(() => {
        callback(data)
    }).catch(() => {

    })
}

export function recurRouter(getRouter = [], allRoutes = []) {
    let resultRoutes = [];
    allRoutes.forEach((i) => {
        getRouter.forEach((item) => {
            if (item.name === i.meta.title) {
                if (item.children && item.children.length > 0) {
                    i.children = recurRouter(item.children, i.children)
                }
                resultRoutes.push(i)
            }
        })
    })
    return resultRoutes;
}